import React from 'react';
import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

export const Accordion = ({
	children,
	id,
	controlButton,
	headerComponent,
	setIsOpen,
	isOpen
}) => {
	const onToggle = () => {
		setIsOpen();
	};

	const handleOnKeyPress = (event) => {
		const keys = ['Enter', 'Space', ' '];
		if (keys.includes(event.key)) {
			onToggle();
		}
	};

	return (
		<section className={styles.accordionWrapper}>
			<div
				role="button"
				aria-controls={`${id}-content`}
				aria-expanded={isOpen}
				onClick={onToggle}
				onKeyDown={handleOnKeyPress}
				tabIndex="0"
				aria-labelledby={`${id}-title`}
			>
				{controlButton}
			</div>
			{!!headerComponent && <>{headerComponent}</>}
			<div aria-hidden={!isOpen} id={`${id}-content`}>
				<CSSTransition
					in={isOpen}
					timeout={300}
					classNames={styles.content}
					unmountOnExit
				>
					<section>{children}</section>
				</CSSTransition>
			</div>
		</section>
	);
};

Accordion.propTypes = {
	children: PropTypes.element.isRequired,
	controlButton: PropTypes.element,
	headerComponent: PropTypes.element.isRequired,
	id: PropTypes.string,
	isOpen: PropTypes.bool.isRequired,
	setIsOpen: PropTypes.func.isRequired
};
